import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'

import { IncidentDrawer as LegacyIncidentDrawer } from './components/IncidentDrawer'
import { IncidentDrawer as DarkIncidentDrawer } from './dark/IncidentDrawer'

export interface IncidentDrawerIProps {
  isOpen: boolean
  onClose: () => void
}

/**
 * The ONE place the incidentDrawerRebrand flag is read for the Incident
 * Drawer. Selects between the Dark Drawer tree (rebrand) and the Legacy
 * Drawer tree (pre-rebrand, behaviorally frozen pending deprecation).
 * Zero flag reads exist below this switch in either tree (ENG-31544).
 */
export const IncidentDrawer = (props: IncidentDrawerIProps) => {
  const isIncidentDrawerRebrand = useFeatureFlag(
    FeatureFlag.incidentDrawerRebrand
  )

  return isIncidentDrawerRebrand ? (
    <DarkIncidentDrawer {...props} />
  ) : (
    <LegacyIncidentDrawer {...props} />
  )
}
